import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { isEqual, map, mapValues } from 'lodash';

import metricsConfig from '../configs/metric-details-config';

import Iframe from '../../components/Iframe';
import PageHeader from '../../components/TitleBanner';
import { TabbedFilters, FilterTypes } from '../../components/Filters';

class CharacterVotesByEpisode extends React.Component {
  componentDidMount() {
    this.initialize();
  }

  componentDidUpdate(prevProps) {
    const { blocked, filters } = this.props;

    if (!blocked) {
      const prevFilterValues = mapValues(prevProps.filters.fields, 'value');
      const nextFilterValues = mapValues(filters.fields, 'value');

      if (!isEqual(nextFilterValues, prevFilterValues)) {
        this.updateLooks();
      }
    }
  }

  componentWillUnmount() {
    const {
      filtersActions: { resetFilters }
    } = this.props;

    resetFilters();
  }

  initialize = () => {
    const {
      updateEpisodeOptionsLoader,
      filtersActions: { getFiltersForPage, updateFilters },
      filters
    } = this.props;

    getFiltersForPage(metricsConfig.CHARACTER_VOTES_PAGE_ID, {
      syncWithUrl: false
    });
    updateFilters({ season: [], episode: [] });
    this.updateShow();
    const filterValues = mapValues(filters, 'value');
    updateEpisodeOptionsLoader(filterValues.season);
  };

  updateShow() {
    const {
      fetchShow,
      match: {
        params: { showId }
      }
    } = this.props;

    fetchShow(showId);
  }

  updateLooks() {
    const {
      embedActions: { getLookerEmbedsForPage },
      filters
    } = this.props;

    getLookerEmbedsForPage(
      metricsConfig.CHARACTER_VOTES_FILTERS,
      filters.fields
    );
  }

  renderTitle() {
    const { showName } = this.props;
    return showName ? (
      <Fragment>
        <em>{showName}: </em>Character Votes by Episode
      </Fragment>
    ) : (
      'Character Votes by Episode'
    );
  }

  render() {
    const { blocked, looks } = this.props;

    return (
      <Fragment>
        <PageHeader>
          <h1 className="tvt-main__header-title">{this.renderTitle()}</h1>
        </PageHeader>

        {blocked && (
          <Iframe
            blocked
            blockedMessage="Contact your Client Success Representative to learn more about this report"
            url=""
            height="100%"
          />
        )}

        {!blocked && (
          <Fragment>
            <TabbedFilters />
            <section className="tvt-main__content">
              {map(looks, l => (
                <Iframe
                  key={l.url}
                  url={l.url}
                  blocked={l.blocked}
                  blockedMessage={l.blockedMessage}
                  height={650}
                />
              ))}
            </section>
          </Fragment>
        )}
      </Fragment>
    );
  }
}

CharacterVotesByEpisode.propTypes = {
  blocked: PropTypes.bool.isRequired,

  embedActions: PropTypes.shape({
    getLookerEmbedsForPage: PropTypes.func.isRequired
  }).isRequired,

  fetchShow: PropTypes.func.isRequired,

  filters: PropTypes.shape({
    fields: FilterTypes.FilterSetType, // eslint-disable-line react/no-typos
    groupings: FilterTypes.GroupingSetType // eslint-disable-line react/no-typos
  }).isRequired,

  filtersActions: PropTypes.shape({
    getFiltersForPage: PropTypes.func.isRequired
  }).isRequired,

  looks: PropTypes.shape({
    characterVotes: PropTypes.shape({})
  }).isRequired,
  match: PropTypes.shape({}).isRequired,

  showName: PropTypes.string.isRequired,

  updateEpisodeOptionsLoader: PropTypes.func.isRequired
};

export default CharacterVotesByEpisode;
